import { render } from "./CartList.vue?vue&type=template&id=61c2088d&scoped=true"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"

import "./CartList.vue?vue&type=style&index=0&id=61c2088d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c2088d"]])

export default __exports__